import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useState, useEffect } from "react";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import moment from "moment";
import request, { gql } from "graphql-request";
import {
  Box,
  Card,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";

const localizer = momentLocalizer(moment);

// const attendance = gql`
//   query userAttendance($id: String!) {
//     userAttendanceDetails(id: $id) {
//       data {
//         id
//         checkIn
//         checkOut
//         totalWorkingHours
//         overtime
//       }
//     }
//   }
// `;

const attendance = gql`
  query GetCalendarUserAttendanceDetails($id: String!) {
    calanderUserAttendanceDetails(id: $id) {
      data {
        id
        user {
          id
          username
        }
        checkIn
        checkOut
        totalWorkingHours
        overtime
      }
      totalPresentDays
      success
      error
      message
    }
  }
`;

const leaveDetails = gql`
  query leaveTrackDetails($empoloyeeid: String!) {
    leaveRequestsByMe(id: $empoloyeeid) {
      data {
        id
        user {
          id
          empid
          username
        }
        requestedOn
        leaveType {
          name
        }
        leaveFrom
        leaveTill
        reason
        totalDays
        teamApproval
        hrApproval
        status
      }
    }
  }
`;

const Callender = () => {
  const [events, setEvents] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = sessionStorage.getItem("user");
  const userId = JSON.parse(user).id;

  const encodedId = btoa(userId);
  const theme = useTheme();

  useEffect(() => {
    const fetchUserAttendance = async () => {
      try {
        const attendanceRes = await request(BASEURL, attendance, {
          id: userId,
        });

        setEvents(attendanceRes.calanderUserAttendanceDetails?.data);
        setLoading(false);
      } catch (err) {
        setError("Error fetching attendance data.");
        setLoading(false);
        console.error("Error fetching check-in data:", err);
      }
    };
    const fetchUserAttendance3 = async () => {
      try {
        const leaveRes = await request(BASEURL, leaveDetails, {
          empoloyeeid: userId,
        });

        setLeaveData(leaveRes?.leaveRequestsByMe?.data);

        setLoading(false);
      } catch (err) {
        setError("Error fetching attendance data.");
        setLoading(false);
        console.error("Error fetching check-in data:", err);
      }
    };

    if (userId) {
      fetchUserAttendance();
      fetchUserAttendance3();
    }
  }, [userId]);

  const getLatestAttendanceData = (data) => {
    if (!Array.isArray(data)) {
      console.error("Expected an array in getLatestAttendanceData, got:", data);
      return [];
    }

    const latestData = {};
    data.forEach((item) => {
      const date = moment(item.checkIn || item.checkOut).format("YYYY-MM-DD");
      if (
        !latestData[date] ||
        moment(item.lastUpdate).isAfter(latestData[date].lastUpdate)
      ) {
        latestData[date] = item;
      }
    });

    return Object.values(latestData);
  };

  const latestAttendanceData = getLatestAttendanceData(events);

  const events1 = latestAttendanceData.map((item) => {
    const checkIn = item.checkIn
      ? moment(item.checkIn).format("hh:mm A")
      : "N/A";
    const checkOut = item.checkOut
      ? moment(item.checkOut).format("hh:mm A")
      : "N/A";
    const totalWorkingHours = item.totalWorkingHours || "N/A";
    const overTime = item?.overtime || "N/A";
    return {
      title: `In: ${checkIn}\nOut: ${checkOut}\nTotal: ${totalWorkingHours} hours\nOT:${overTime}hours`,
      start: item.checkIn
        ? moment(item.checkIn).toDate()
        : item.checkOut
          ? moment(item.checkOut).toDate()
          : null,
      end: item.checkOut
        ? moment(item.checkOut).toDate()
        : item.checkIn
          ? moment(item.checkIn).toDate()
          : null,
      totalWorkingHours: item.totalWorkingHours,

      type: "attendance",
    };
  });

  const eventStyleGetter = (event) => {
    let backgroundColor;

    if (event.type === "attendance") {
      backgroundColor = "#f38875";
      if (event.start && event.end && event.totalWorkingHours !== "N/A") {
        const hours = parseFloat(event.totalWorkingHours);
        if (hours >= 8) {
          // backgroundColor = "rgba(0, 128, 0, 0.8)";
          backgroundColor = "#88fd8b ";
        } else if (hours >= 0) {
          backgroundColor = "lightgrey";
        }
      }
    } else if (event.type === "leave") {
      if (event?.title == "Sick Leave") {
        backgroundColor = "#4FC3F7";
      } else if (event?.title == "Cacusal Leave") {
        backgroundColor = "#FFB74D";
      } else if (event?.title == "Earned Leave") {
        backgroundColor = "#81C784";
      } else if (event?.title == "Loss Of Pay") {
        backgroundColor = "#E57373";
      } else if (event?.title == "Privilege Leave") {
        backgroundColor = "#9575CD";
      } else if (event?.title == "Annual Leave") {
        backgroundColor = "#FF8A65";
      } else if (event?.title == "Maternity Leave") {
        backgroundColor = "#FF4E88";
      } else if (event?.title == "Paternity Leave") {
        backgroundColor = "#B1C29E";
      } else if (event?.title == "Restricted Holiday") {
        backgroundColor = "#FCF596";
      } else {
        backgroundColor = "#4FC3F7";
      }
    }

    const style = {
      backgroundColor,
      borderRadius: "10px",
      opacity: 1,
      color: "white",
      border: "1px solid #fff",
      boxShadow: "0px 3px 5px rgba(0,0,0,0.2)",
      padding: "2px 10px",
      display: "block",
      marginTop: "-15px",
    };

    return { style };
  };
  const formatText = (text) => {
    if (typeof text !== "string") return "";
    return text
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const leaveEvents = leaveData
    .filter((leave) => leave.status === "approved")
    .map((leave) => ({
      title: formatText(leave.leaveType?.name),
      start: moment(leave.leaveFrom).toDate(),
      end: moment(leave.leaveTill).toDate(),
      type: "leave",
    }));
  console.log("Leave Events:", leaveEvents);
  console.log("Attendance Events:", events1);
  const CustomEvent = ({ event }) => {
    const lines = event.title.split("\n");

    return (
      <Box
        sx={{
          fontSize: "10px",
          color: "#fff",
          borderRadius: "5px",
          border: `0px solid ${
            lines == "Sick Leave" ? "white" : theme.palette.primary.main
          }`,
          whiteSpace: "pre-wrap",
        }}
      >
        {lines.map((line, index) => {
          return (
            <p key={index} variant="body2" style={{ fontSize: "12px" }}>
              {line}
            </p>
          );
        })}
      </Box>
    );
  };

  const filteredAttendanceEvents = events1.filter((attendanceEvent) => {
    return !leaveEvents.some((leaveEvent) => {
      return (
        moment(attendanceEvent.start).isSameOrAfter(
          moment(leaveEvent.start),
          "day",
        ) &&
        moment(attendanceEvent.start).isSameOrBefore(
          moment(leaveEvent.end),
          "day",
        )
      );
    });
  });

  const finalEvents = [...filteredAttendanceEvents, ...leaveEvents];
  
  console.log(filteredAttendanceEvents, "filteredAttendanceEvents");
  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: "20px",
        }}
      >
        {loading ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" variant="h6" align="center">
            {error}
          </Typography>
        ) : (
          <Box
            sx={{
              backgroundColor: theme.palette.background.paper,
              borderRadius: "16px",
              padding: "20px",
              position: "relative",
              zIndex: 0,
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              "& .rbc-month-row": {
                minHeight: "110px",
              },
              "& .rbc-date-cell": {
                padding: "12px",
                fontSize: "10px",
              },
            }}
          >
            <Calendar
              localizer={localizer}
              events={finalEvents}
              startAccessor="start"
              endAccessor="end"
              style={{
                minHeight: 500,
                width: "100%",
                borderRadius: "16px",
                marginBottom: "44px",
              }}
              eventPropGetter={eventStyleGetter}
              components={{
                event: CustomEvent,
              }}
            />

            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              gap={2}
              flexWrap="wrap"
            >
              {[
                { label: "working hours greater than 8", color: "#4CAF50" },
                { label: "Casual Leave (CL)", color: "#FFB74D" },
                { label: "Sick Leave (SL)", color: "#4FC3F7" },
                { label: "working hours less than 8", color: "lightgrey" },
                { label: "Privilege Leave (PL)", color: "#9575CD" },
                { label: "Earned Leave (EL)", color: "#81C784" },
                { label: "Loss of Pay (LP)", color: "#E57373" },
                { label: "Annual Leave(AL)", color: "#FF8A65" },
                { label: "Paternity Leave(PAL)", color: "#B1C29E" },
                { label: "Restricted Holiday(RH)", color: "#FCF596" },
                { label: "Maternity Leave(ML)", color: "#FF4E88" },
                { label: "Unapproved", color: "#616161" },
              ].map((legend) => (
                <Box key={legend.label} display="flex" alignItems="center">
                  <Box width={16} height={16} bgcolor={legend.color} mr={1} />
                  <Typography variant="body2">{legend.label}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default Callender;
